/** Canonical action-type order and labels for Flow editor tabs and Actions page filters. */

export const ACTION_TYPE_FILTERS = [
  { id: 'sms', label: 'SMS' },
  { id: 'email', label: 'Email' },
  { id: 'sip', label: 'SIP Call' },
  { id: 'voice', label: 'Voice Call' },
  { id: 'wait', label: 'Wait' },
  { id: 'webhook', label: 'Webhook' },
  { id: 'rest', label: 'REST' },
  { id: 'device', label: 'Device' },
  { id: 'image_display', label: 'Image Display' },
  { id: 'push', label: 'Notification' },
];

export const ACTION_TYPES = ACTION_TYPE_FILTERS.map((item) => item.id);

export const ACTION_TYPE_FILTERS_STORAGE_KEY = (uid) => `actions_type_filters_v2_${uid || 'anon'}`;

export function actionTypeLabel(id) {
  const match = ACTION_TYPE_FILTERS.find((item) => item.id === id);
  if (match) return match.label;
  if (String(id || '') === 'desktop') return 'Desktop';
  return String(id || 'Action');
}

export function uiTypeFor(action) {
  try {
    const t = String(action?.type || '').toLowerCase();
    if (t.startsWith('twilio_')) return t.replace('twilio_', '');
    if (t === 'voice_call' || t === 'voice') return 'voice';
    if (t === 'device_action' || t === 'device') return 'device';
    if (t === 'desktop_action' || t === 'desktop') return 'desktop';
    if (t === 'push' || t === 'push_notification' || t === 'notification') return 'push';
    if (t === 'wait' || t === 'delay') return 'wait';
    if (t === 'rest') return 'rest';
    if (t === 'image_display') return 'image_display';
    if (t === 'webhook') return 'webhook';
    return t || 'sms';
  } catch (_) {
    return 'sms';
  }
}

export function matchesActionTypeFilter(action, selectedTypes) {
  const selected = selectedTypes instanceof Set ? selectedTypes : new Set(selectedTypes || []);
  if (!selected.size) return false;
  return selected.has(uiTypeFor(action));
}

/** When exactly one known action type is filtered, use it as the Add Action default. */
export function singleSelectedActionType(selectedTypes) {
  const selected = selectedTypes instanceof Set ? selectedTypes : new Set(selectedTypes || []);
  if (selected.size !== 1) return null;
  const [only] = selected;
  return ACTION_TYPES.includes(only) ? only : null;
}

export function formatWaitDuration(action) {
  const ms = Number(action?.parameters?.durationMs ?? action?.durationMs);
  if (!Number.isFinite(ms) || ms < 0) return '';
  if (ms % 3600000 === 0) return `${ms / 3600000}h`;
  if (ms % 60000 === 0) return `${ms / 60000} min`;
  if (ms % 1000 === 0) return `${ms / 1000}s`;
  return `${ms} ms`;
}
